<app-cardholder-details
  *ngIf="cardholder"
  [cardholder]="cardholder"
  (newCardholderSelected)="showNewCardholder($event)"
>
</app-cardholder-details>

<!-- ACH Form  -->
<form
  name="achFundForm"
  [formGroup]="achFundForm"
  (ngSubmit)="saveAchFunds()"
  *ngIf="achfundingInfo"
  novalidate
>
  <div
    class="card card-nc"
    *ngIf="hasEntitlements('CARDHOLDERS_ACHFUNDING_LINKED_BANK_ACCOUNT')"
  >
    <div class="card-heading">
      <i class="fa fa-link"></i>
      <span class="panelHeaderHeading">
        LINKED BANK ACCOUNT
      </span>
      <span
        *ngIf="hasEntitlements('CARDHOLDERS_ACHFUNDING_UPDATE')"
        class="pull-right save-panel"
      >
        <button
          type="submit"
          [disabled]="save_ach_btn"
          [ngClass]="save_ach_btn_spinner"
          class="btn btn-nc save-panel-btn"
        >
          SAVE
        </button>
      </span>
    </div>
    <div
      *ngIf="hasEntitlements('CARDHOLDERS_ACHFUNDING_UPDATE')"
      class="card-body labelCommon"
    >
      <div class="row cardRowBackground">
        <div class="col-md-4">
          <label for="achAllowed" class="control-label"> ACH Allowed </label>
        </div>
        <div class="col-md-4">
          <label for="status" class="control-label"> Status </label>
        </div>
        <div class="col-md-4">
          <label for="achDeclineCount" class="control-label">NSF Count</label>
        </div>
      </div>
      <div class="row cardRowBackground">
        <div class="form-group col-md-4">
          <div class="col-md-10 zeroPadding">
            <select
              class="form-control input-sm"
              id="achAllowed"
              formControlName="achAllowed"
            >
              <option *ngFor="let ans of ['Y', 'N']" [ngValue]="ans">
                {{ ans | yesNo }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group col-md-4">
          <div
            class="col-md-10 zeroPadding"
          >
            <select
              class="form-control input-sm"
              id="status"
              formControlName="status"
              name="status"
              required
            >
              <option
                *ngFor="let value of isActiveValues"
                [ngValue]="value.value"
                >{{ value.label }}</option
              >
            </select>
          </div>
          <div class="col-md-1 zeroPadding"></div>
          <div
            [ngClass]="
              achfundingInfo.replenishMethods.isActive === 'Y'
                ? 'circleGreen'
                : 'circleRed'
            "
            class="col-md-1 zeroPadding float-right zeroPadding"
            style="margin-top: -20px;"
          ></div>
        </div>
        <div class="form-group col-md-4">
          <div class="col-md-10 zeroPadding">
            <select
              class="form-control input-sm"
              id="achDeclineCount"
              formControlName="achDeclineCount"
              name="achDeclineCount"
              required
            >
              <option
                value="{{ achDeclineCountNewOption }}"
                *ngIf="achDeclineCountNewOption"
              >
                {{ achDeclineCountNewOption }}
              </option>
              <option value="0">0</option>
              <option value="99">99</option>
            </select>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-2 columnBorder">
          <label for="srcAcctName" class="control-label"
            >Name on Account
          </label>
        </div>
        <div class="col-md-2 columnBorder">
          <label for="srcABANum" class="control-label">Routing Number</label>
        </div>
        <div class="col-md-2 columnBorder">
          <label for="srcAcctNum" class="control-label text-nowrap"
            >Bank Account Number
          </label>
        </div>
        <div class="col-md-2 columnBorder">
          <label for="srcAcctType" class="control-label">Account Type </label>
        </div>
        <div class="col-md-2">
          <label for="srcORGType" class="control-label">Banking Type </label>
        </div>
      </div>
      <div class="row" *ngIf="achfundingInfo.customerAccount.achAllowed != 'N'">
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding">
            <input
              type="text"
              class="form-control input-sm"
              id="srcAcctName"
              formControlName="srcAcctName"
            />
            <span
              class="help-block has-error validationMessage"
              *ngIf="
                !formHandle.srcAcctName.valid && formHandle.srcAcctName.touched
              "
            >
              <span *ngIf="formHandle.srcAcctName.errors['invalidSrcAcctName']">
                Only less than 22 letters, numbers, hyphen and spaces is allowed
              </span>
              <span *ngIf="formHandle.srcAcctName.errors.required">
                Required
              </span>
              <span *ngIf="formHandle.srcAcctName.errors.maxlength">
                Account name can only be 22 characters
              </span>
            </span>
          </div>
        </div>
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding">
            <input
              type="text"
              class="form-control input-sm"
              formControlName="srcABANum"
              id="srcABANum"
            />
            <span
              class="help-block has-error validationMessage"
              *ngIf="
                formHandle.srcABANum.invalid && formHandle.srcABANum.touched
              "
            >
              <span *ngIf="formHandle.srcABANum.errors['invalidRoutingNumber']">
                Invalid routing number
              </span>
              <span *ngIf="formHandle.srcABANum.errors.required"
                >. Required
              </span>
              <span *ngIf="formHandle.srcABANum.errors.maxlength">
                Routing Number can only be 9 characters
              </span>
            </span>
          </div>
        </div>
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding">
            <input
              type="text"
              class="form-control input-sm"
              formControlName="srcAcctNum"
              id="srcAcctNum"
              maxlength="20"
              placeholder="{{ bankAccountNumberPlaceholder }}"
            />
            <span
              class="help-block has-error validationMessage"
              *ngIf="
                !formHandle.srcAcctNum.valid && formHandle.srcAcctNum.touched
              "
            >
              <span *ngIf="formHandle.srcAcctNum.errors['invalidSrcAcctNum']">
                Account Number must be numeric
              </span>
              <span *ngIf="formHandle.srcAcctNum.errors.required">
                Required
              </span>
              <span
                *ngIf="
                  formHandle.srcAcctNum.errors.maxlength &&
                  !formHandle.srcAcctNum.errors['invalidSrcAcctNum']
                "
              >
                Length cannot exceed 16 digits
              </span>
            </span>
          </div>
        </div>
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding">
            <select
              class="form-control input-sm"
              id="srcAcctType"
              formControlName="srcAcctType"
              required
            >
              <option value="C">Checking</option>
              <option value="S">Savings</option>
            </select>
          </div>
        </div>
        <div class="form-group col-md-2">
          <div class="col-md-12 zeroPadding">
            <select
              class="form-control input-sm"
              id="srcORGType"
              formControlName="srcORGType"
              required
            >
              <option value="C">Consumer</option>
              <option value="B">Business</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="achfundingInfo.customerAccount.achAllowed == 'N'">
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding staticText1">
            {{ achfundingInfo?.replenishMethods?.srcAcctName }}
          </div>
        </div>
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding staticText1">
            {{ achfundingInfo?.replenishMethods?.srcABANum }}
          </div>
        </div>
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding staticText1">
            {{ achfundingInfo?.replenishMethods?.srcAcctNum }}
          </div>
        </div>
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding staticText1">
            {{ achfundingInfo?.replenishMethods?.srcAcctType | accountType }}
          </div>
        </div>
        <div class="form-group col-md-2">
          <div class="col-md-12 zeroPadding staticText1">
            {{ achfundingInfo?.replenishMethods?.srcORGType | bankingType }}
          </div>
        </div>
      </div>

      <div class="row" *ngIf="hasEntitlements('TODO_BANK_ADDRESS')">
        <div class="col-md-2 columnBorder">
          <label for="srcAcctBankCity" class="control-label">Bank City</label>
        </div>
        <div class="col-md-2 columnBorder">
          <label for="srcAcctBankState" class="control-label">Bank State</label>
        </div>
        <div class="col-md-2 columnBorder">
          <label for="srcAcctBankZip" class="control-label">Bank Zip</label>
        </div>
      </div>

      <div
        class="row"
        *ngIf="
          achfundingInfo.customerAccount.achAllowed != 'N' &&
          hasEntitlements('TODO_BANK_ADDRESS')
        "
      >
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding">
            <input
              type="text"
              class="form-control input-sm"
              id="srcAcctBankCity"
              formControlName="srcAcctBankCity"
              maxlength="34"
              placeholder="Bank City"
            />
            <span
              class="help-block has-error validationMessage"
              *ngIf="
                formHandle.srcAcctBankCity.invalid &&
                formHandle.srcAcctBankCity.touched &&
                formHandle.srcAcctBankCity.errors.required
              "
            >
              Required
            </span>
          </div>
        </div>
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding">
            <input
              type="text"
              class="form-control input-sm"
              id="srcAcctBankState"
              formControlName="srcAcctBankState"
              maxlength="2"
              placeholder="Bank State"
              required
            />
            <span
              class="help-block has-error validationMessage"
              *ngIf="
                formHandle.srcAcctBankState.invalid &&
                formHandle.srcAcctBankState.touched &&
                formHandle.srcAcctBankState.errors.required
              "
            >
              Required
            </span>
          </div>
        </div>
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding">
            <input
              type="text"
              class="form-control input-sm"
              id="srcAcctBankZip"
              formControlName="srcAcctBankZip"
              maxlength="10"
              placeholder="Bank Zip"
              required
            />
            <span
              class="help-block has-error validationMessage"
              *ngIf="
                formHandle.srcAcctBankZip.invalid &&
                formHandle.srcAcctBankZip.touched &&
                formHandle.srcAcctBankZip.errors.required
              "
            >
              Required
            </span>
          </div>
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          achfundingInfo.customerAccount.achAllowed == 'N' &&
          hasEntitlements('TODO_BANK_ADDRESS')
        "
      >
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding staticText1">
            {{ achfundingInfo?.bankAddress?.city }}
          </div>
        </div>
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding staticText1">
            {{ achfundingInfo?.bankAddress?.state }}
          </div>
        </div>
        <div class="form-group col-md-2 columnBorder">
          <div class="col-md-12 zeroPadding staticText1">
            {{ achfundingInfo?.bankAddress?.zip }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="card-body"
      *ngIf="!hasEntitlements('CARDHOLDERS_ACHFUNDING_UPDATE')"
    >
      <div class="row cardRowBackground labelCommon">
        <div class="col-md-4">
          <label class="control-label"> ACH Allowed </label>
        </div>
        <div class="col-md-4">
          <label class="control-label"> Status </label>
        </div>
        <div class="col-md-4">
          <label class="control-label">NSF Count</label>
        </div>
      </div>

      <div class="row cardRowBackground staticText1">
        <div class="col-md-4">
          <label for="achAllowed" class="control-label">
            {{ achfundingInfo.customerAccount.achAllowed | yesNo }}
          </label>
        </div>
        <div class="col-md-4">
          <label for="Status" class="control-label">
            {{ achfundingInfo.replenishMethods.isActive | yesNoStatus }}
          </label>
        </div>
        <div class="col-md-4">
          <label class="control-label">
            {{ achfundingInfo.customerAccount.achDeclineCount }}
          </label>
        </div>
      </div>
      <br />
      <div class="row labelCommon">
        <div class="col-md-2 columnBorder">
          <label class="control-label">Name on Account </label>
        </div>
        <div class="col-md-2 columnBorder">
          <label class="control-label">Routing Number</label>
        </div>
        <div class="col-md-2 columnBorder">
          <label class="control-label text-nowrap">Bank Account Number </label>
        </div>
        <div class="col-md-2 columnBorder">
          <label class="control-label">Account Type </label>
        </div>
        <div class="col-md-2">
          <label class="control-label">Banking Type </label>
        </div>
      </div>

      <div class="row staticText1">
        <div class="col-md-2 columnBorder">
          <label class="control-label"
            >{{ achfundingInfo.replenishMethods.srcAcctName }}
          </label>
        </div>
        <div class="col-md-2 columnBorder">
          <label class="control-label"
            >{{ achfundingInfo.replenishMethods.srcABANum }}
          </label>
        </div>
        <div class="col-md-2 columnBorder">
          <label class="control-label"
            >{{ bankAccountNumberPlaceholder }}
          </label>
        </div>
        <div class="col-md-2 columnBorder">
          <label class="control-label"
            >{{ achfundingInfo.replenishMethods.srcAcctType | accountType }}
          </label>
        </div>
        <div class="col-md-2">
          <label class="control-label"
            >{{ achfundingInfo.replenishMethods.srcORGType | bankingType }}
          </label>
        </div>
      </div>

      <div class="row labelCommon" *ngIf="hasEntitlements('TODO_BANK_ADDRESS')">
        <div class="col-md-2 columnBorder">
          <label class="control-label">Bank City</label>
        </div>
        <div class="col-md-2 columnBorder">
          <label class="control-label">Bank State</label>
        </div>
        <div class="col-md-2 columnBorder">
          <label class="control-label">Bank Zip</label>
        </div>
      </div>

      <div class="row staticText1" *ngIf="hasEntitlements('TODO_BANK_ADDRESS')">
        <div class="col-md-2 columnBorder">
          <label class="control-label">{{
            achfundingInfo.bankAddress.city
          }}</label>
        </div>
        <div class="col-md-2 columnBorder">
          <label class="control-label">{{
            achfundingInfo.bankAddress.state
          }}</label>
        </div>
        <div class="col-md-2 columnBorder">
          <label class="control-label">{{
            achfundingInfo.bankAddress.zip
          }}</label>
        </div>
      </div>
    </div>
  </div>

  <div
    class="card card-nc"
    *ngIf="
      hasEntitlements('CARDHOLDERS_ACHFUNDING_FUND_REFUND') &&
      achfundingInfo.customerAccount.achAllowed == 'Y' &&
      achfundingInfo.replenishMethods.isActive == 'Y'
    "
  >
    <div class="card-heading">
      <span class="icon-NC_history"></span>
      <span class="panelHeaderHeading"> ACH FUNDING/REFUND</span>
      <span class="pull-right save-panel">
        <button
          type="submit"
          [disabled]="save_ach_btn"
          [ngClass]="save_ach_btn_spinner"
          class="btn btn-nc save-panel-btn"
        >
          TRANSFER
        </button>
      </span>
    </div>
    <div class="card-body">
      <div class="row labelCommon">
        <div class="col-md-4">
          <label for="fundRefund" class="col-md-12 control-label">
            To Request Funding/Refund
          </label>
          <div class="form-group col-md-10">
            <select
              class="form-control input-sm"
              id="fundRefund"
              formControlName="fundRefund"
              [(ngModel)]="achfundingInfo.fundRefund"
            >
              <option
                *ngFor="let fundRefund of fundRefunds"
                [ngValue]="fundRefund.id"
              >
                {{ fundRefund.value }}
              </option>
            </select>
          </div>
        </div>
        <div *ngIf="achfundingInfo.fundRefund !== 'N'" class="col-md-4">
          <label for="fundAmt" class="col-md-12 control-label">
            Requesting Amount
          </label>
          <div class="form-group col-md-10">
            <input
              type="text"
              class="form-control input-sm"
              id="fundAmt"
              formControlName="fundAmt"
              maxlength="9"
              placeholder="0.00"
            />
            <span
              class="help-block has-error validationMessage"
              *ngIf="!formHandle.fundAmt.valid && formHandle.fundAmt.touched"
            >
              <span
                *ngIf="
                  formHandle.fundAmt.errors['invalidRequestingAmountUndefined']
                "
              >
                Amount is mandatory when submitting an account funding request.
              </span>
              <span
                *ngIf="
                  formHandle.fundAmt.errors['invalidRequestingAmountBadRange']
                "
              >
                Amount should be more than $0.01 and less than $999999.99
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="card card-nc"
    *ngIf="hasEntitlements('CARDHOLDERS_ACHFUNDING_HISTORY')"
  >
    <div class="card-heading">
      <div class="row">
        <div class="col-xs-4 col-md-4">
          <span class="icon-NC_history"></span>
          <span class="panelHeaderHeading">
            ACH FUNDING HISTORY
          </span>
        </div>
        <div class="col-xs-4 col-md-4">
          <div class="row">
            <div class="col-xs-3 col-md-3 calHeading">Start Date</div>
            <div class="col-xs-8 col-md-8">
              <div class="input-group datepicker dtpicker-btn">
                <input
                  id="tranMinDate"
                  class="form-control"
                  formControlName="tranMinDate"
                  [maxDate]="endDate"
                  (dateSelect)="changeStartDate($event)"
                  (select)="changeStartDate($event)"
                  (change)="changeStartDate($event)"
                  ngbDatepicker
                  #d1="ngbDatepicker"
                />
                <div class="input-group-append">
                  <button
                    class="fa fa-calendar"
                    (click)="d1.toggle()"
                    type="button"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-4 col-md-4">
          <div class="row">
            <div class="col-xs-3 col-md-3 calHeading">End Date</div>
            <div class="col-xs-8 col-md-8">
              <div class="input-group datepicker dtpicker-btn">
                <input
                  id="tranMaxDate"
                  class="form-control"
                  formControlName="tranMaxDate"
                  [minDate]="startDate"
                  (dateSelect)="changeEndDate($event)"
                  (select)="changeEndDate($event)"
                  (change)="changeEndDate($event)"
                  ngbDatepicker
                  #d2="ngbDatepicker"
                />
                <div class="input-group-append">
                  <button
                    class="fa fa-calendar"
                    (click)="d2.toggle()"
                    type="button"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <table class="table tableBackground tableRow table-bordered table-hover">
      <thead class="transactionHistHeader tableheading">
        <tr>
          <th class="text-center">DATE</th>
          <th class="text-center">POSTED</th>
          <th class="text-center">ABA</th>
          <th class="text-center">ACCOUNT</th>
          <th class="text-center">STATUS</th>
          <th class="text-center">RETURN MESSAGE</th>
          <th class="text-center">AMOUNT</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="achFunds == null || achFunds.length == 0">
          <td align="center" colspan="7" style="height: 150px;">
            No account activity found.
          </td>
        </tr>
        <tr *ngFor="let achFund of achFunds">
          <td class="transactionHistText text-center">
            {{ achFund.requestDate | date: 'mediumDate' }}
          </td>
          <td class="transactionHistText text-center">
            {{ achFund.postDate | date: 'mediumDate' }}
          </td>
          <td class="transactionHistText text-center">
            {{ achFund.bankAbaNumber }}
          </td>
          <td class="transactionHistText text-center">
            {{ achFund.bankAccountNumber }}
          </td>
          <td class="transactionHistText text-center">
            {{ achFund.statType }}
          </td>
          <td
            class="transactionHistText text-center"
            *ngIf="achFund.achReturnMessage"
          >
            {{ achFund.achReturnMessage }}, Ref# {{ achFund.transaction }}
          </td>
          <td
            class="transactionHistText text-center"
            *ngIf="!achFund.achReturnMessage"
          >
            Ref# {{ achFund.transaction }}
          </td>
          <td class="transactionHistText text-center">
            {{ achFund.amount | currency | minusSignToParens }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</form>
